import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification, Select } from "antd";
import QrReader from "react-qr-scanner";
import qrActions from "../../../redux/qr/actions";

export const url = () => {
  if (window.location.href.includes("happysportal.unrealsoft.bg")) {
    return "https://happys.mymenu.info/";
  }

  if (window.location.href.includes("happyportal.unrealsoft.bg")) {
    return "https://happy.mymenu.info/";
  }

  if (window.location.href.includes("portal.unrealsoft.bg")) {
    return "https://web.mymenu.info/";
  }
  if (window.location.href.includes("portaldev.unrealsoft.bg")) {
    return "https://webdev.mymenu.info/";
  }

  // return "https://localhost:3000/";
  return "https://webdev.mymenu.info/";
};

const { Option } = Select;

const QRManagementScanner = () => {
  const [selected, setSelected] = useState("environment");
  const { showScanner, originalTouchSaleTables } = useSelector(
    (state) => state.qrReducer
  );
  const { scanQRTable } = qrActions;
  const dispatch = useDispatch();

  const handleScan = (result) => {
    if (showScanner) {
      if (result && result.text && result.text.includes(url())) {
        dispatch(scanQRTable(result.text.replace(url(), "")));
      }
    }
  };

  const handleError = (err) => {
    notification["error"]({
      message: "Грешка при сканиране",
    });
  };

  return (
    showScanner && (
      <div>
        <div className="qr-management-scanner-select-container">
          <p className="qr-management-select-camera-title">Изберете камера:</p>
          <Select
            className="qr-management-scanner-select-camera"
            value={selected}
            onChange={(value) => {
              setSelected(value);
            }}
          >
            <Option value={"environment"}>Задна Камера</Option>
            <Option value={"user"}>Предна Камера</Option>
          </Select>
        </div>
        {originalTouchSaleTables.length > 0 && (
          <QrReader
            className="qr-management-scanner"
            constraints={{ video: { facingMode: selected } }}
            delay={500}
            onScan={handleScan}
            onError={handleError}
          />
        )}
      </div>
    )
  );
};

export default QRManagementScanner;
